import { escapeHtml, openPrintWindow, tableHtmlFromRows } from './exportUtils';
import { formatDateIN } from './dateFormat';
import { displayCorrespondenceCategory } from '../data/categoryFieldConfig';

export const getChainEntries = (chainId, entries) => (
  (entries || [])
    .filter(e => e.chain_id === chainId)
    .sort((a, b) => new Date(b.letter_date) - new Date(a.letter_date))
);

export const getChainAttachments = (chainId, entries) => (
  getChainEntries(chainId, entries).flatMap((entry) =>
    (entry.attachments || []).map((file) => ({
      ...file,
      entry_id: entry.id,
      ref_no: entry.ref_no,
      letter_date: entry.letter_date,
      direction: entry.direction,
    }))
  )
);

const buildThreadReportHtml = ({ chain, project, entries }) => {
  if (!chain) return { bodyHtml: '', title: '' };
  const orderedEntries = getChainEntries(chain.id, entries || []);
  const rows = orderedEntries.map((entry) => {
    const attachmentNames = (entry.attachments || []).map((f) => f.name).join(', ');
    const attachmentCount = (entry.attachments || []).length;
    const attachmentDisplay = attachmentCount > 0 ? `${attachmentCount} (${attachmentNames})` : '0';
    return [
      entry.ref_no,
      entry.direction,
      entry.from,
      entry.to,
      formatDateIN(entry.letter_date),
      entry.mode,
      entry.summary,
      attachmentDisplay,
    ];
  });
  const bodyHtml = `
    <h2>${escapeHtml(chain.subject)}</h2>
    <div class="meta">
      Project: <strong>${escapeHtml(project?.name || '-')}</strong> |
      Category: <strong>${escapeHtml(displayCorrespondenceCategory(chain.category || 'General'))}</strong> |
      Priority: <strong>${escapeHtml(chain.severity)}</strong> |
      Status: <strong>${escapeHtml(chain.status)}</strong> |
      Last letter date: <strong>${escapeHtml(formatDateIN(chain.last_entry_date))}</strong>
    </div>
    <h3>Inward / Outward Entries</h3>
    ${tableHtmlFromRows({
      headers: ['Reference', 'Direction', 'From', 'To', 'Date', 'Mode', 'Summary', 'Attachments'],
      rows,
      emptyMessage: 'No entries available',
    })}
  `;
  return { bodyHtml, title: 'Correspondence Register - Thread Report' };
};

export const getThreadReportForPreview = buildThreadReportHtml;

export const printCorrespondenceThread = ({ chain, project, entries }) => {
  const { bodyHtml, title } = buildThreadReportHtml({ chain, project, entries });
  if (!bodyHtml) return;
  openPrintWindow({ title, subtitle: '', bodyHtml });
};
